import { LiquidProductionTATEnum } from "../../../common/enums/LiquidProductionTATEnum";
import { ITankBatteryModel } from "../../../services/tank-relationship-data-service/Models";
import { TankRelationshipStateType } from "../TankRelationshipsViewState";

export type TankBatteryTableModel = {

} & ITankBatteryModel;

const TankBatteryTableViewUtils = {

    shapeData: function (models: ITankBatteryModel[],
        state: TankRelationshipStateType
    ): ITankBatteryModel[] {
        
        const filteredData = models.filter(o => o.displayText.toLowerCase().indexOf(state.filterText.toLowerCase()) !== -1 || state.filterText.trim() === '');

        filteredData.flatMap(o => o.tanks).forEach(o => {
            o.dualPhase = o.tags.find(v => v.tagAssociationType.id === LiquidProductionTATEnum.InterfaceLevel) !== undefined;
        });

        return filteredData;
    }
}

export default TankBatteryTableViewUtils;
